// Italian

const lang = {
  gateMediaPreviewHeader: 'Forse potrebbe interessarti',
  loadmore: 'Altro',
  nextMedia: 'Media successivo',
  previousMedia: 'Media precedente',
  closePost: 'Chiudi post',
  nextPost: 'Post successivo',
  previousPost: 'Post precedente',
  outOfStock: 'Esaurito',
  numberOfReviews(n) {
    return n === 1 ? 'recensione' : 'recensioni'
  },
  reportFormField: 'Inserisci un messaggio',
  reportPost: 'Segnala post',
  reportFormTitle: 'Vuoi segnalare questa immagine?',
  reportFormDetails: `Se ritieni che l'immagine sia inappropriata, illegale o violi i diritti di qualcuno, puoi segnalare il contenuto. Se segnali l'immagine/il testo, i moderatori del contenuto saranno avvisati e verranno prese le misure appropriate.`,
  reportFormMessagePlaceholder: 'Specifica il motivo della segnalazione',
  reportFormMessageLabel: 'Messaggio',
  reportFormEmailLabel: 'La tua email',
  reportFormSubmitButtonText: 'Invia segnalazione',
  reportFormCancelButtonText: 'Annulla',
  reportFormSentTitle: 'Grazie per la segnalazione!',
  reportFormSentCloseButtonText: 'Chiudi modale',
  cardAndTileAriaLabel: 'Elenco di post da account su varie piattaforme social',
  carouselAriaLabel: 'Carosello con post da account su varie piattaforme social',
  singleAriaLabel: 'Di seguito è riportato un post da un account di social media',
  poweredBy: 'Alimentato da Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` publicata il ${date}` : ''
    const createdByString = userName ? ` di ${userName}` : ''
    return `Foto${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Carica i tuoi contenuti multimediali',
  openTheGate: 'Apri la finestra di dialogo',
  gridRoleDescription: 'griglia',
  carouselRoleDescription: 'carosello',
  tiktokVideoAriaLabel: 'Video TikTok incorporato. Premi play per visualizzare il contenuto.',
  feedThumbnailAriaLabel: (postIndex, maxPosts) =>
    `Miniatura media ${postIndex + 1} di ${maxPosts}, apre una finestra con contenuti social e lista di prodotti in evidenza.`,
  carouselControlButtonsAriaLabel: 'Pulsanti di controllo del carosello',
  gateCarouselIndicatorAriaLabel: (mediaIndex, maxMedia) =>
    `Media ${mediaIndex + 1} di ${maxMedia}`,
  showMoreCaption: 'Mostra più didascalia',
  showLessCaption: 'Mostra meno didascalia',
  originalPrice: (price) => `Prezzo originale: ${price}`,
  salesPrice: (price) => `Prezzo in offerta: ${price}`,
  postPublishedBy: 'Post pubblicato da',
  mediaAltText: (isVideo, username, date, altText) => {
    const mediaType = isVideo ? 'Video' : 'Immagine'
    const user = username ? `${username}` : 'utente sconosciuto'
    const publishDate = date ? `il ${date}` : ''
    return `${mediaType} pubblicato da ${user} ${publishDate}. Può essere ${altText}`
  },
  gateSlideAriaLabel: (postIndex, maxPosts) => `Post ${postIndex + 1} di ${maxPosts}.`,
}

export default lang
